<template>
  <div>
    <business-agreement></business-agreement>
    <user-agreement></user-agreement>
    <customer-agreement></customer-agreement>
  </div>
</template>

<script>
import businessAgreement from "./BusinessAgreement";
import userAgreement from "./UserAgreement";
import customerAgreement from "./CustomerAgreement";
export default {
  components: {
    businessAgreement,userAgreement,customerAgreement
  },
  data() {
    return {};
  },

  methods: {}
};
</script>
<style scoped >
</style>



// WEBPACK FOOTER //
// src/views/userAgreements/registerAgreement.vue